import { DateTime } from 'luxon';
import { SubjectData } from 'shell/models/person';
import { CitizenshipVM } from 'shell/view-models/citizenship';

export const transformCitizenship = (subjectData: SubjectData): CitizenshipVM[] =>
  subjectData.cittadinanza?.map((citizenship) => ({
    code: citizenship.codiceStato || '',
    validityDate: citizenship?.dataValidita
      ? DateTime.fromISO(citizenship.dataValidita).toFormat('dd/MM/yyyy')
      : '',
    citizenship: citizenship.descrizioneStato || '',
    note: citizenship.noteStato || '',
  })) || [];
